import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import logo from '../../assets/images/web.png';
import { setData } from '../../core/redux/app/Actions';

const ModulesAestheticScreen = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const showDropdownItems = (id, field) => {
    dispatch(setData({ [field]: id }));
  };
  const user = useSelector((state) => state.app.user || {});

  // Verifica se o usuário tem permissão para ver "Tipos de serviço"
  const canViewServiceTypes = !!user?.isSuperAdmin;

  return (
    <div className="dashboard-placement">
      <div className="dashboard-home">
        <div>
          <img className="dashboard-logo" src={logo} />
        </div>
        <div className="dashboard-button-placement">
          {canViewServiceTypes && (
            <div
              className="location-button"
              onClick={() => {
                history.push(`/aesthetic`);
                showDropdownItems(1, 'aesthetic');
                dispatch(setData({ navigate: `/aesthetic` }));
              }}
            >
              <text>Etapas do processo</text>
            </div>
          )}
          <div
            className="location-button"
            onClick={() => {
              history.push(`/aesthetic`);
              showDropdownItems(2, 'aesthetic');
              dispatch(setData({ navigate: `/aesthetic` }));
            }}
          >
            <text>Serviços</text>
          </div>
          <div
            className="location-button"
            onClick={() => {
              history.push(`/aesthetic`);
              showDropdownItems(3, 'aesthetic');
              dispatch(setData({ navigate: `/aesthetic` }));
            }}
          >
            <text>Pacotes</text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModulesAestheticScreen;
